"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildScannedProjects = buildScannedProjects;
const dep_graph_1 = require("./dep-graph");
function buildScannedProjects(mavenGraphs, includeTestScope = false, verboseEnabled = false, fingerprintMap = new Map(), includePurl = false, showMavenBuildScope = false, hashLabelsMap = new Map(), remoteRepositoriesMap = new Map()) {
    const context = {
        includeTestScope,
        verboseEnabled,
        fingerprintMap,
        includePurl,
        showMavenBuildScope,
        hashLabelsMap,
        remoteRepositoriesMap,
    };
    const scannedProjects = [];
    for (const mavenGraph of mavenGraphs) {
        const depGraph = (0, dep_graph_1.buildDepGraph)(mavenGraph, context);
        scannedProjects.push({ depGraph });
    }
    return { scannedProjects };
}
//# sourceMappingURL=scanned-project-builder.js.map